import React from "react";
import { Modal, Botao, Icon, IconDrConsulta } from "@drconsulta/library";
import intl from 'react-intl-universal';

import style from "./modal-error.module.scss";
import { ModalErrorProps } from "./modal-props.model";

class ModalError extends React.Component<ModalErrorProps> {

    getMensagem(){
        if(this.hasMessage()){
            return this.props.errorMessage.response.data.message;
        }

        return "Ocorreu um erro inesperado, por favor contacte o administrador para mais informações.";
    }

    hasMessage(){
        return this.props.errorMessage && "response" in this.props.errorMessage && "message" in this.props.errorMessage.response.data;
    }

    render() {
        return (
            <Modal mostrarModal={this.props.mostrarModal} fecharModal={() => this.props.fecharModal()}>
                <div className={style.conteudo}>
                    <div className={style.center}>
                        <Icon icone={IconDrConsulta.FailIcon} colorDrConsulta={"rosa"} tipo={"drConsulta"} className={style.iconeDanger} />
                        <div className={style.titulo}>{intl.getHTML("modal.errors.titulo")}</div>
                        <div className={style.subtitulo}>
                            {this.getMensagem()}
                        </div>

                        <div className={style.footer}>
                            <Botao tamanho='grande' onClick={() => this.props.fecharModal()} >
                                {intl.getHTML("modal.errors.botao")}
                            </Botao>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ModalError;
